import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import { AppWebviewLayout } from '../../_metronic/layout/AppWebviewLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import { useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import SetupData from '../data/SetupData'

const PrivateRoutes = () => {
  const DashboardPage = lazy(() => import('../pages/DashboardPage'))
  const ProfilePage = lazy(() => import('../pages/ProfilePage'))
  const PropertyPage = lazy(() => import('../pages/PropertyPage'))
  const PropertyMasterPage = lazy(() => import('../pages/PropertyMasterPage'))
  const WorkshopPage = lazy(() => import('../pages/WorkshopPage'))
  const TermAndConditionPage = lazy(() => import('../pages/TermAndConditionPage'))
  const ContactPage = lazy(() => import('../pages/ContactPage'))
  const PropertyForm = lazy(() => import('../forms/PropertyForm'))
  const GroupListingPage = lazy(() => import('../pages/GroupListingPage'))
  const GroupListingApplicationForm = lazy(() => import('../forms/GroupListing/GroupListingApplicationForm'))
  const GroupListingDetailForm = lazy(() => import('../forms/GroupListing/GroupListingDetailForm'))
  const ViewListingPage = lazy(() => import('../pages/ViewListingPage'))
  const GroupListingForm = lazy(() => import('../forms/GroupListing/GroupListingForm'))
  const DraftsListingPage = lazy(() => import('../pages/DraftsListingPage'))
  const PropertyPostingPage = lazy(() => import('../pages/PropertyPostingPage'))
  const PackageSubscribePage = lazy(() => import('../pages/PackageSubscribePage'))
  const PaymentStatusPage = lazy(() => import('../pages/PaymentStatusPage'))
  const PaymentHistoryPage = lazy(() => import('../pages/PaymentHistoryPage'));
  const PropMasterFormWebview = lazy(() => import('../appWebview/PropertyMasterFormWebview'))
  const PropFormWebview = lazy(() => import('../appWebview/PropertyFormWebview'))
  const DraftListingWebview = lazy(() => import('../appWebview/DraftsListingPageWebview'))

  const agentSlice = useSelector((state: RootState) => state.agent)
  const trrAgent = (agentSlice?.companyName?.trim() === SetupData.trrCompany);
  let postingAccess = false;
  // if (agentSlice._id) postingAccess = SetupData.postingAgents.includes(agentSlice._id);
  if (agentSlice.postingAccess) postingAccess = agentSlice.postingAccess;
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {agentSlice.newTnc === false ?
          <>
            <Route
              path='dashboard'
              element={
                <SuspensedView>
                  <DashboardPage />
                </SuspensedView>
              }
            />
            <Route
              path='profile'
              element={
                <SuspensedView>
                  <ProfilePage />
                </SuspensedView>
              }
            />
            <Route
              path='properties'
              element={
                <SuspensedView>
                  <PropertyPage />
                </SuspensedView>
              }
            />
            <Route
              path='master'
              element={
                <SuspensedView>
                  <PropertyMasterPage />
                </SuspensedView>
              }
            />
            <Route
              path='guidance'
              element={
                <SuspensedView>
                  <WorkshopPage />
                </SuspensedView>
              }
            />
            <Route
              path='tnc'
              element={
                <SuspensedView>
                  <TermAndConditionPage />
                </SuspensedView>
              }
            />
            <Route
              path='properties/form/:propId'
              element={
                <SuspensedView>
                  <PropertyForm />
                </SuspensedView>
              }
            />
            <Route
              path='properties/draftslisting'
              element={
                <SuspensedView>
                  <DraftsListingPage />
                </SuspensedView>
              }
            />
            {postingAccess && <Route
              path='properties/posting/:type/:platform'
              element={
                <SuspensedView>
                  <PropertyPostingPage />
                </SuspensedView>
              }
            />}
            {trrAgent &&
              <>
                <Route
                  path='grouplisting'
                  element={
                    <SuspensedView>
                      <GroupListingPage />
                    </SuspensedView>
                  }
                />
                <Route
                  path='grouplisting/newgroup'
                  element={
                    <SuspensedView>
                      <GroupListingApplicationForm />
                    </SuspensedView>
                  }
                />
                <Route
                  path='grouplisting/detail/:groupId'
                  element={
                    <SuspensedView>
                      <GroupListingDetailForm />
                    </SuspensedView>
                  }
                />
                <Route
                  path='grouplisting/:groupId'
                  element={
                    <SuspensedView>
                      <ViewListingPage />
                    </SuspensedView>
                  }
                />
                <Route
                  path='grouplisting/form/:propId'
                  element={
                    <SuspensedView>
                      <GroupListingForm />
                    </SuspensedView>
                  }
                />
              </>
            }
            <Route
              path='package-subscription'
              element={
                <SuspensedView>
                  <PackageSubscribePage />
                </SuspensedView>
              }
            />
            <Route
              path='payment/:status'
              element={
                <SuspensedView>
                  <PaymentStatusPage />
                </SuspensedView>
              }
            />
            <Route
              path='contact'
              element={
                <SuspensedView>
                  <ContactPage />
                </SuspensedView>
              }
            />
            <Route
              path='payment-history'
              element={
                <SuspensedView>
                  <PaymentHistoryPage />
                </SuspensedView>
              }
            />
          </> :
          <Route
            path='tnc'
            element={
              <SuspensedView>
                <TermAndConditionPage />
              </SuspensedView>
            }
          />
        }
      </Route>
      <Route element={<AppWebviewLayout />}>
        <Route
          path='webview/master/form'
          element={
            <SuspensedView>
              <PropMasterFormWebview />
            </SuspensedView>
          }
        />
        <Route
          path='webview/property/form/:propId'
          element={
            <SuspensedView>
              <PropFormWebview />
            </SuspensedView>
          }
        />
        <Route
          path='webview/property/drafts'
          element={
            <SuspensedView>
              <DraftListingWebview />
            </SuspensedView>
          }
        />
      </Route>
      <Route path='*' element={<Navigate to={agentSlice.newTnc === true ? '/tnc' : '/dashboard'} />} />
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
